export default {
    ASC: "ASC",
    DESC: "DESC"
};

export const SortOrderText = {
    ASC: "asc",
    DESC: "desc"
};
